import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import memoize from 'memoize-one';

import { indexJointCommitteeRequest, deleteJointCommitteeRequest } from '../../requests/jointCommittees';
import { ComponentDataTable, DefaultModal, BasicActionBtns } from '../../components';
import { sendAlert } from '../../actions/utils';

const columns = memoize(clickHandler => [
  {
    name: 'CÓDIGO',
    selector: 'code',
    sortable: true,
    grow: '1'
  },
  {
    name: 'NOMBRE',
    selector: 'name',
    sortable: true,
    grow: '1'
  },
  {
    name: 'DIRECCIÓN',
    selector: 'address',
    cell: item => item.full_address,
    sortable: true,
    grow: '1'
  },
  {
    name: 'ACCIONES',
    cell: item => <BasicActionBtns item={item} resource="JointCommittee" clickHandler={clickHandler} />,
    ignoreRowClick: true,
    allowOverflow: false,
    button: true,
    grow: '1',
    minWidth: '123px'
  }
]);

class JointCommitteeDataTable extends Component {
  state = {
    onRequest: true,
    jointCommittees: [],
    amount: 0,
    moreData: false,
    modalShow: false,
    modalItem: null,
    modalBody: '',
    disabled: false
  };

  handleRequest = async params => {
    const { dispatch } = this.props;
    this.setState({
      onRequest: true
    });
    indexJointCommitteeRequest({
      dispatch,
      params,
      successCallback: this.handleSuccessIndex
    });
  };

  handleSuccessIndex = response => {
    const jointCommittees = response.data.data;
    const { amount } = response.data.metadata;
    this.setState({
      jointCommittees,
      amount,
      onRequest: false,
      disabled: false
    });
  };

  removeJointCommittee = jointCommitteeId => {
    const { dispatch } = this.props;
    this.setState({
      disabled: true
    });
    deleteJointCommitteeRequest(jointCommitteeId, {
      dispatch,
      successCallback: this.handleSuccessRemove('Comite Eliminado Correctamente')
    });
  };

  handleButtonClick = (item, action) => {
    const { history } = this.props;
    switch (action) {
      case 'show':
        history.push(`/joint_committees/${item.id}`);
        break;
      case 'edit':
        history.push(`/joint_committees/${item.id}/edit`);
        break;
      case 'destroy':
        this.setState({
          modalShow: true,
          modalItem: item,
          modalBody: '¿Estás seguro que deseas eliminar este comité?'
        });
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
        break;
    }
  };

  handleModalClose = () => {
    this.setState({
      modalShow: false
    });
  };

  handleModalConfirm = () => {
    const { modalItem } = this.state;
    this.removeJointCommittee(modalItem.id);
  };

  handleSuccessRemove = message => {
    this.handleModalClose();
    const { moreData } = this.state;
    const { dispatch } = this.props;
    dispatch(sendAlert({ kind: 'success', message }));
    this.setState({ moreData: !moreData });
  };

  render() {
    const { jointCommittees, amount, onRequest, moreData, modalShow, modalBody, disabled } = this.state;
    return (
      <>
        <ComponentDataTable
          onRequest={onRequest}
          columns={columns(this.handleButtonClick)}
          data={jointCommittees}
          totalRows={amount}
          moreData={moreData}
          resourceRequest={this.handleRequest}
          onRowClicked={item => this.handleButtonClick(item, 'show')}
          pointerOnHover
        />
        <DefaultModal
          title="Eliminar Comité"
          body={modalBody}
          show={modalShow}
          handleClose={this.handleModalClose}
          handleConfirm={this.handleModalConfirm}
          titleBtnClose="Cancelar"
          titleBtnSave="Confirmar"
          disabled={onRequest || disabled}
        />
      </>
    );
  }
}

export default withRouter(connect()(JointCommitteeDataTable));
